import { render, staticRenderFns } from "./reply-details.vue?vue&type=template&id=66915c91&scoped=true&"
import script from "./reply-details.vue?vue&type=script&lang=js&"
export * from "./reply-details.vue?vue&type=script&lang=js&"
import style0 from "./reply-details.vue?vue&type=style&index=0&id=66915c91&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66915c91",
  null
  
)

export default component.exports